module.exports = __webpack_public_path__ + "static/media/VPM_mobile_1.169c8b02.jpg";